import { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EFVideoModal from '@/components/UI/EFVideoModal';
import { createEFPic } from '@/utils/useEFPic';
import { youtubeVideoMap } from '@/constants/glacier';
import { useGlobal } from '@/utils/useGlobal';
import { handleDynamicPath } from '@/utils/handleDynamicPath';

const asset = '/media/glacier-portable-refrigerator/pc/';
const { EFPic } = createEFPic(asset);

export default function FirstKv() {
    const { gtm } = useGlobal();
    const { t } = useLang('glacier.detail.firstKv');
    const [videoModal, setVideoModal] = useState(false);
    const [isCrowd, setIsCrowd] = useState(false);
    const { locale } = useRouter();
    const [showAni, setShowAni] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);
    let flag = 1;

    const youtubeVideo = youtubeVideoMap[locale as keyof typeof youtubeVideoMap] || youtubeVideoMap.us;

    useEffect(() => {
        const hasCrowd = document.querySelector('.crowdFundingPC');
        setIsCrowd(!!hasCrowd);
        const video: any = videoRef.current;
        const textTriggerHook = !!hasCrowd ? 0 : 1;
        const textOffset = !!hasCrowd ? 0 : '-40%';
        console.log(isCrowd);
        if (!!hasCrowd) {
            AniContainer.create({
                triggerElement: '.firstKv',
                triggerHook: 1,
                offset: '50%',
                duration: '50%',
                onEnter: () => {
                    if (flag === 1) {
                        flag += 1;
                        video && video.play();
                    }
                },
            });
        }
        AniContainer.create({
            asyncFromTo: [['.firstKv .first-kv', { opacity: 1 }, { opacity: 0 }, 1]],
            triggerElement: '.firstKv',
            triggerHook: textTriggerHook,
            offset: textOffset,
            duration: '80%',
            asyncTimeLine: [0],
        });
        const setAniFnc = () => {
            if (video && video.currentTime && video.currentTime > 7) {
                setShowAni(true);
            }
        };
        video?.addEventListener('timeupdate', setAniFnc);
        return () => {
            video?.removeEventListener('timeupdate', setAniFnc);
        };
    }, []);

    const playerVideo = () => {
        setVideoModal(true);
        const isBird = !!document.querySelector('.crowdfunding-tabs-nav');
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow GLACIER',
            position: isBird ? 'Product_1' : 'Product Detail_1',
        });
    };

    useEffect(() => {
        if (locale === 'au') {
            setTimeout(() => {
                setShowAni(true);
            }, 1000);
        }
    }, []);

    return (
        <div className={`firstKv ${css.firstKv}`}>
            <div className="first-kv">
                {locale !== 'au' && (
                    <video
                        ref={videoRef}
                        className={`ef-video kv-video ${showAni ? 'ani-video' : ''}`}
                        playsInline
                        // eslint-disable-next-line react/no-unknown-property
                        webkit-playsinline="true"
                        // eslint-disable-next-line react/no-unknown-property
                        x5-playsinline="true"
                        // eslint-disable-next-line react/no-unknown-property
                        x5-video-player-type="h5-page"
                        loop={false}
                        muted
                        src={handleDynamicPath(`${asset}first_kv_detail.mp4`)}
                        autoPlay={!isCrowd}
                    ></video>
                )}
                {/*<EFVideo*/}
                {/*    ref={videoRef}*/}
                {/*    className={`kv-video ${showAni ? 'ani-video' : ''}`}*/}
                {/*    loop={false}*/}
                {/*    muted*/}
                {/*    autoPlay={false}*/}
                {/*    sources={[`${asset}first_kv_detail.webp`, `${asset}first_kv_detail.mp4`]}*/}
                {/*/>*/}
                <EFPic className={`kv-img ${showAni ? 'ani-img' : ''}`} name={['first_kv_bg.jpg', 'first_kv_bg.jpg']} />
                <div className={`kv-box ${showAni ? 'box-opacity' : ''}`}>
                    <div className="kv-text">
                        <p className={`kv-title ${showAni ? 'ani-title' : ''}`}>{t('title')}</p>
                        <p className={`kv-desc ${showAni ? 'ani-desc' : ''}`}>{t('subTitle')}</p>
                        <div className={`kv-btn ${showAni ? 'ani-btn' : ''}`} onClick={() => playerVideo()}>
                            <span className="kv-btn__text">{t('btn_text')}</span>
                            <span className="kv-btn__svg"></span>
                        </div>
                    </div>
                </div>
            </div>
            <EFVideoModal
                visible={videoModal}
                source={youtubeVideo}
                onClose={() => setVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
